<div id="taxpayer-profile" class="page-layout simple tabbed">
  <!-- HEADER -->
  <div
    class="header p-24"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end"
  >
    <div
      class="user-info"
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayout.gt-sm="row"
      fxLayoutAlign.gt-sm="start center"
    >
      <form
        *ngIf="imagenForm"
        fxLayout="column"
        fxLayoutAlign="center center"
        [formGroup]="imagenForm"
      >
        <img
          class="profile-image avatar huge"
          *ngIf="account$ | async as account"
          (click)="fileInput.click()"
          [src]="sanitizeImagen(account)"
        />
        <input
          hidden
          accept="image/*"
          type="file"
          (change)="handleFile($event)"
          #fileInput
        />
        <span
          class="cambiar-logo-base cambiar-logo pointer"
          (click)="fileInput.click()"
          >Cambiar</span
        >
      </form>
      <div
        class="name"
        [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }"
      >
        {{ nombreUsuario }}
      </div>
    </div>

    <div
      class="actions"
      fxLayout="row"
      fxLayoutAlign="end center"
      [@animate]="{ value: '*', params: { delay: '200ms' } }"
    >
      <button mat-raised-button color="accent" aria-label="Follow">
        Follow
      </button>
      <button mat-raised-button color="accent" aria-label="Send Message">
        Send Message
      </button>
    </div>
  </div>
  <!-- / HEADER -->

  <!-- CONTENT -->
  <div class="content">
    <mat-tab-group
      mat-stretch-tabs
      class="example-stretched-tabs mat-elevation-z4"
      color="accent"
    >
      <mat-tab label="Mi Firma">
        <app-my-signature></app-my-signature>
      </mat-tab>
      <mat-tab label="Mi Negocio" *ngIf="!disableMyBussines">
        <app-my-business></app-my-business>
      </mat-tab>
      <mat-tab label="Mi Banco"> </mat-tab>
      <mat-tab label="Mi Curriculum"> </mat-tab>
      <mat-tab label="Mis Contactos"> </mat-tab>
      <mat-tab label="Mi Cuenta"> </mat-tab>
    </mat-tab-group>
  </div>
  <!-- / CONTENT -->
</div>
